module.exports = __webpack_public_path__ + "static/media/banner-fraude.9a34028f.png";